<template>
  <div v-if="engine && model">
    <div class="row">
      <div class="col-12 col-md-8">
        <h2 class="page-title">
          <router-link :to="`/sites/${engine.site}/engines/${$route.params.engineId}`">
              <i class="icon-minimal-left tim-icons" />
          </router-link>
          Revisione <span v-if="engine"> - {{engine.name}} ({{engine.registrationNumber}}) <span v-if="site"> - {{site.name}}</span></span>
        </h2>
      </div>
      <div class="col-12 col-md-4 text-md-right">
        <router-link
          class="text-info small"
          v-if="user.is('backoffice') && model.phase =='final'"
          :to="`/engines/${$route.params.engineId}/revisions/${model.initialRevision}`"
          >
            <b>Vari alla revisione tecnica</b> <i class="icon-minimal-right tim-icons" />
        </router-link>
      </div>
    </div>
    <revision-form
      v-if="model"
      :site="site"
      :model="model"
      :on-submit="updateRevisionSubmit"
      submit-message="Crea" />
  </div>
  <loading v-else />
</template>
<script>
import axios from 'axios'
import RevisionForm from '@/components/Revisions/RevisionForm.vue'

import { mapState, mapActions } from 'vuex'

export default{
  computed: {
    ...mapState({
      revisions: state => state.revisions.revisions.docs,
      site: state => state.sites.site,
      loading: state => state.engines.loading,
      user: state => state.account.user,
      engine: state => state.engines.engine,
    }),
  },
  async mounted() {
    const {engineId, id} = this.$route.params;
    const revision = await this.get({engineId, id});
    const {data} = await axios.get(`/api/revisions?phase=final`)
    
    this.model =  {
      ...revision,
      phase: 'final',
      revisionDate: new Date(),
      initialRevision: revision.id,
      id: null,
      number: data.nextNumber,
      workedDetails: {
        ...revision.workedDetails,
        additionalLines: [{}],
        detailsSingleAmount: {}
      }
    }
    this.getEngine({id: engineId})
  },
  watch: {
    engine: function(newValue) {
      if (newValue !== null){
        this.model.engine = newValue.id
        this.getSite(newValue.site)
      }
    },
  },
  data() {
    return {
      model: null,
    }
  },
  components: {
    RevisionForm
  },
  methods: {
    ...mapActions('engines', {
      getEngine: 'get'
    }),
    ...mapActions('sites', {
      getSite: 'get'
    }),
    ...mapActions('revisions', {
      get: 'get',
      create: 'create',
      update: 'update'
    }),
    updateRevisionSubmit() {
      this.create({
        engineId: this.$route.params.engineId,
        revision: this.model,
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
} 
</script>